import { render, staticRenderFns } from "./VerificarEmailComponent.vue?vue&type=template&id=5a4f3218&scoped=true&"
import script from "./VerificarEmailComponent.vue?vue&type=script&lang=js&"
export * from "./VerificarEmailComponent.vue?vue&type=script&lang=js&"
import style0 from "@/components/auth/auth-form.css?vue&type=style&index=0&id=5a4f3218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f3218",
  null
  
)

export default component.exports